import React, { useEffect, useState, FC } from 'react';
import FindProductSection from '../findProductSection';
import { TCHProductDashLinesItem } from '../../types/productDashboard.types';
import { TLinkField } from '../../../../types/sitecore.types';
import Icon from '../../../@shared/icon';
import { iconSize } from '../../../../constants/icon.constants';
import './styles.scss';

export type TProductNavigationSection = {
  menuData: TCHProductDashLinesItem[];
  findProduct?: TLinkField;
  onClick: (indexValue: number) => void;
};

const ProductNavigationSection: FC<TProductNavigationSection> = (props) => {
  const [clickedIndex, setClickedIndex] = useState({});
  const { menuData, findProduct, onClick } = props;

  const handleNavItemClick = (clickedBtnInd: number): void => {
    setClickedIndex({ [clickedBtnInd]: true });
    onClick(clickedBtnInd);
  };

  useEffect(() => {
    setClickedIndex({ 0: true });
  }, []);

  return (
    <div className="product-dashboard-menu">
      <ul className="product-dashboard-tabs">
        {menuData?.map((item, index) => {
          return (
            <li key={index} className={`product-dashboard-tabs__tab ${clickedIndex[index] ? 'product-dashboard-tabs__tab--selected' : ''}`}>
              <button className="product-dashboard-tabs__tab--button" onClick={(): void => handleNavItemClick(index)}>
                {item?.iconAsset && (
                  <Icon
                    iconField={item?.iconAsset}
                    color="complement"
                    size={iconSize.dsklg}
                    extraClassName="product-dashboard-tabs__tab--icon"
                  />
                )}
                {item?.title && <h3 className="product-dashboard-tabs__tab--label">{item?.title}</h3>}
              </button>
            </li>
          );
        })}
      </ul>
      {findProduct?.value?.text && findProduct?.value?.href && <FindProductSection findProduct={findProduct} />}
    </div>
  );
};

export default React.memo(ProductNavigationSection);
